module.exports = __webpack_public_path__ + "static/media/ZL-vs-Pendo chart.67d516ea.svg";